<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xVtPg3/tc-custom/9781460344798.jpg?1728259163885" alt="This image is the cover for the book Marriage Made in Money, The Penniless Lords"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marriage Made in Money, The Penniless Lords
      </h1>
      <p class="bookDescription body article font2">
        <b>A young woman with a scandalous secret finds love with a down-and-out Earl in this historical romance set one year before the Regency era.</b><br/><br/><i>London, 1810</i>. After her first marriage ended in disaster, wealthy heiress Amethyst Cameron swore she’d never take a husband again. Yet her beloved father’s deepest wish is for her to wed an aristocrat. It is the only way to protect her life and reputation.<br/><br/>Lord Montcliffe must marry into money to save his debt-ridden estate, but he doesn’t have to like it—or his bewitching future bride. So he’s stunned by the feelings stirred up by one scorching kiss! But when Daniel uncovers the truth, can he accept the real Amethyst and help to banish the ghost of her past forever?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sophia James
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?443ebb65